import React from 'react';
import { useAppContext } from '../../store/appContext';
import Footer from '../../components/Footer/Footer';
import { MainBodyWrapper, RootWrapper } from './styled';
import EuCookieBanner from '../../components_common/EuCookieBanner/EuCookieBanner';
import UnsupportedBrowser from '../../components_common/UnsupportedBrowser/UnsupportedBrowser';
import checkUnsupportedBrowser from '../../helpers/checkUnsupportedBrowser';
import Banner from '../../components_common/Banner';
import Header from '../../components/Header/Header';
import { useShippingSelector } from '../../hooks/useShippingSelector';
import timerQueue, { EventType } from '../../helpers/TimerQueue';

const AppDesktop = ({ children }) => {
  const acceptCookies = () => {
    timerQueue.addEvent({
      callback: () => window.location.reload(),
      type: EventType.Navigation,
    });
  };
  const { euCookiePolicyAccepted, isEu, currPage } = useAppContext();
  const { browserIsNotSupported, browserName } = checkUnsupportedBrowser();
  const { isShippingSelectorVisible, changeShippingVisibility } = useShippingSelector();

  return (
    <RootWrapper>
      <Banner />
      <Header
        changeShippingVisibility={changeShippingVisibility}
        isShippingSelectorVisible={isShippingSelectorVisible}
        currPage={currPage}
      />
      <MainBodyWrapper id="main">
        {browserIsNotSupported ? <UnsupportedBrowser isDesktop browserName={browserName} /> : <>{children}</>}
      </MainBodyWrapper>
      {isEu && !euCookiePolicyAccepted && <EuCookieBanner isDesktop handleClick={acceptCookies} />}
      <Footer changeShippingVisibility={changeShippingVisibility} />
    </RootWrapper>
  );
};

export default AppDesktop;
